import { HttpErrorResponse } from '@angular/common/http';
import { Certificate } from 'app/library/certificate/models/certificate.model';

export class SetPublicCertificates {
    static readonly type = '[PublicCertificates] SetPublicCertificates';

    constructor(public payload: Certificate[]) {}
}

export class UnsetPublicCertificates {
    static readonly type = '[PublicCertificates] UnsetPublicCertificates';
}

export class FetchPublicCertificates {
    static readonly type = '[PublicCertificates] FetchPublicCertificates';
}

export class FetchPublicCertificatesSuccess {
    static readonly type = '[PublicCertificates] FetchPublicCertificatesSuccess';

    constructor(public payload: Certificate[]) {}
}

export class FetchPublicCertificatesFailure {
    static readonly type = '[PublicCertificates] FetchPublicCertificatesFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class ToggleSelectedPublicCertificate {
    static readonly type = '[PublicCertificates] ToggleSelectedPublicCertificate';

    constructor(public payload: string) {}
}

export class SelectFilteredPublicCertificates {
    static readonly type = '[PublicCertificates] SelectFilteredPublicCertificates';
}

export class DeselectSelectedPublicCertificates {
    static readonly type = '[PublicCertificates] DeselectSelectedPublicCertificates';
}

export class SearchPublicCertificates {
    static readonly type = '[PublicCertificates] SearchPublicCertificates';

    constructor(public payload: string) {}
}
